import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoModelo145 = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoModelo145 = () => {
  const [loadingGetInfoModelo145, setLoadingGetInfoModelo145] = useState(false);
  const [successGetInfoModelo145, setSuccessGetInfoModelo145] = useState(false);
  const [errorGetInfoModelo145, setErrorGetInfoModelo145] = useState<any>(null);
  const [dataGetInfoModelo145, setDataGetInfoModelo145] = useState<any>(null);

  const [statusGetInfoModelo145, setStatusGetInfoModelo145] =
    useState<StatusGetInfoModelo145>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoModelo145 = async (
    userId: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoModelo145(true);
    setSuccessGetInfoModelo145(false);
    setErrorGetInfoModelo145(null);

    try {
      const res = await apiRecord.getInfoModelo145It(userId);

      setStatusGetInfoModelo145({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoModelo145(true);
      setDataGetInfoModelo145(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;
    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetInfoModelo145({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoModelo145(err);
      console.error("Error en getInfoModelo145:", err);

      throw err;

    } finally {
      setLoadingGetInfoModelo145(false);
    }
  };

  return {
    getInfoModelo145,
    loadingGetInfoModelo145,
    successGetInfoModelo145,
    errorGetInfoModelo145,
    dataGetInfoModelo145,
    statusGetInfoModelo145
  };
};

export default useGetInfoModelo145;
